import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'app/app.constants';
import { IRunnerLogPage } from 'app/shared/model/FDERunnerLogsService/runner-log.model';

@Injectable({ providedIn: 'root' })
export class RunnerLogsService {
    public resourceUrl = SERVER_API_URL + 'api/v2/logs';

    constructor(protected http: HttpClient) {}

    query(runner: string, account: string, stream: string, since: string): Observable<HttpResponse<IRunnerLogPage>> {
        let params = new HttpParams().set('runner', runner);
        if (account) {
            params = params.set('account', account);
        }
        if (stream) {
            params = params.set('stream', stream);
        }
        if (since) {
            params = params.set('since', since);
        }
        return this.http.get<IRunnerLogPage>(this.resourceUrl, { params, observe: 'response' });
    }
}
